import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  news: NewsItem;
  variant?: "row" | "block";
}

export default function NewsCard({ news, variant = "row" }: NewsCardProps) {
  if (variant === "block") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-full aspect-[4/3] overflow-hidden bg-background-200">
          <img
            src={news.cover}
            alt={`${news.title} 配图`}
            title={`${news.title} - CC视频资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-4">
          <span className="inline-block px-2 py-0.5 rounded bg-accent-100 text-accent-800 text-xs">
            {news.category}
          </span>
          <h3 className="mt-2 font-medium text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
            {news.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-500 line-clamp-2">{news.summary}</p>
          <p className="mt-3 text-xs text-foreground-400">{news.date}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-32 h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`${news.title} 配图`}
          title={`${news.title} - CC视频资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-400">
          <span className="text-accent-700">{news.category}</span>
          <span>·</span>
          <span>{news.date}</span>
        </div>
        <h3 className="mt-1.5 font-medium text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
          {news.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-500 line-clamp-2 hidden sm:block">
          {news.summary}
        </p>
      </div>
    </Link>
  );
}